// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditTwoToneSvg from "@ant-design/icons-svg/es/asn/EditTwoTone";
import AntdIcon from '../components/AntdIcon';

var EditTwoTone = function EditTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditTwoToneSvg
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
export default React.forwardRef(EditTwoTone);